import { createSlice } from "@reduxjs/toolkit";

interface MessageInitialStateModel {
  userFilter:any;
  messageDetilsFilter:any
  messageDetailsListData:any
}
const messageInitialState: MessageInitialStateModel = {
  userFilter:{
    PageIndex:1,
    PageSize:20,
   
    
  },
  messageDetilsFilter:{
    PageIndex:1,
    PageSize:-1,
    ContactUserId:null,
    AdvertId:null,
    
  },
  messageDetailsListData:[]
};

const messageSlice = createSlice({
  name: "messageSlice ",
  initialState: messageInitialState,
  reducers: {
    handleSetUserMessageFilter: (state, action) => {
      state.userFilter= action.payload.filter;
    },
    handleSetMessageDetailsFilter: (state, action) => {
      state.messageDetilsFilter= action.payload.filter;
    },
    handleSetMessageDetaisList: (state, action) => {
   
      
      state.messageDetailsListData= action.payload.data;
    
    },
    
  
  },
});

export const {
  handleSetMessageDetailsFilter,
  handleSetUserMessageFilter,
  handleSetMessageDetaisList
} = messageSlice.actions;
export default messageSlice;
